import { FontWeightTheme } from '@kite-js/theme-types';

const weights: FontWeightTheme = {
    Light: '300',
    Normal: '400',
    Medium: '500',
    Strong: '700',
};

export default weights;
